export default {"src":"/_next/static/media/Grievance.c3f4b06a.svg","height":33,"width":32};